import axios from 'axios'
import { createApp } from 'vue'
import { deleteAccount } from '~/js/sections/delete-me'

const ID_CUSTOMERS_REGISTER = 'js-customers-resign'

document.addEventListener('DOMContentLoaded', () => {
  const elementCustomersResign = document.getElementById(ID_CUSTOMERS_REGISTER)
  if (!elementCustomersResign) return

  const checkTexts = elementCustomersResign.dataset.checkTexts.split(',')
  const { accountLogoutUrl } = elementCustomersResign.dataset
  const checks = new Array(checkTexts.length).fill(null).map((_) => false)

  createApp({
    name: 'TemplatesCustomersResign',
    data() {
      return {
        checkTexts,
        checks,
        isProcessing: false,
      }
    },
    computed: {
      isSubmitValid() {
        return this.checks.every((v) => v) && !this.isProcessing
      },
    },
    methods: {
      async onSubmit($event) {
        this.isProcessing = true
        await deleteAccount($event.target)
        await axios.get(accountLogoutUrl)
        $event.target.form.submit()
      },
    },
  }).mount(elementCustomersResign)
})
